import { useState } from 'react';
import { api } from '../lib/api';
import { useAction, useApi } from '../lib/useApi';
import { Empty, ErrorBox, Notice, PageHeader, StatusBadge, fmtDate, money } from '../components/ui';

export function LegacyBookPage() {
  const editions = useApi<{ editions: Array<{ key: string; label: string; priceCents: number }> }>('/legacy-book/editions');
  const orders = useApi<{ orders: Array<{ id: string; title: string; edition: string; price_cents: number; status: string; created_at: string; story_ids: string[] }> }>('/legacy-book/orders');
  const stories = useApi<{ stories: Array<{ id: string; title: string; type: string }> }>('/stories?status=approved');
  const act = useAction();
  const [title, setTitle] = useState('Ìtàn Ìdílé Wa — Our Family Stories');
  const [edition, setEdition] = useState('hardcover');
  const [chosen, setChosen] = useState<Set<string>>(new Set());

  return (
    <>
      <PageHeader title="Legacy Book" termKey="page.legacy_book" lead="A printed heirloom of your family’s approved stories, proverbs and recipes — in Yoruba and English." />
      <Notice text={act.notice} />
      <ErrorBox error={act.error} />
      <div className="grid grid-2">
        <form
          className="card stack"
          onSubmit={async (e) => {
            e.preventDefault();
            await act.run(() => api('/legacy-book/orders', { body: { title, edition, storyIds: [...chosen] } }), 'Draft created. Check out when ready.');
            orders.reload();
          }}
        >
          <h2>Design your book</h2>
          <label className="field">
            <span className="label">Title</span>
            <input className="yo" value={title} onChange={(e) => setTitle(e.target.value)} required />
          </label>
          <fieldset className="field" style={{ border: 0, padding: 0 }}>
            <legend className="label">Edition</legend>
            {editions.data?.editions.map((ed) => (
              <label key={ed.key} className="check">
                <input type="radio" name="edition" checked={edition === ed.key} onChange={() => setEdition(ed.key)} /> {ed.label} — {money(ed.priceCents)}
              </label>
            ))}
          </fieldset>
          <fieldset className="field" style={{ border: 0, padding: 0 }}>
            <legend className="label">Stories (only native-speaker-approved stories can be printed)</legend>
            {stories.data?.stories.length === 0 && <Empty>No approved stories yet.</Empty>}
            {stories.data?.stories.map((s) => (
              <label key={s.id} className="check">
                <input
                  type="checkbox"
                  checked={chosen.has(s.id)}
                  onChange={(e) => {
                    const n = new Set(chosen);
                    if (e.target.checked) n.add(s.id);
                    else n.delete(s.id);
                    setChosen(n);
                  }}
                />
                <span className="yo">{s.title}</span> <span className="small muted">({s.type})</span>
              </label>
            ))}
          </fieldset>
          <button className="btn" disabled={!chosen.size || act.busy}>
            Create draft
          </button>
        </form>
        <section className="card">
          <h2>Orders</h2>
          {orders.data?.orders.length === 0 && <Empty>No orders yet.</Empty>}
          {orders.data?.orders.map((o) => (
            <div key={o.id} className="spread" style={{ borderTop: '1px solid var(--line)', padding: '10px 0' }}>
              <div>
                <strong className="yo">{o.title}</strong>
                <div className="small muted">
                  {o.edition} · {o.story_ids.length} stories · {money(o.price_cents)} · {fmtDate(o.created_at, false)} <StatusBadge status={o.status} />
                </div>
              </div>
              {['draft', 'awaiting_payment'].includes(o.status) && (
                <button
                  className="btn small"
                  onClick={async () => {
                    const r = await act.run(() => api<{ checkoutUrl: string }>(`/legacy-book/orders/${o.id}/checkout`, { method: 'POST', body: {} }));
                    if (r?.checkoutUrl) window.location.href = r.checkoutUrl;
                  }}
                >
                  Pay & print
                </button>
              )}
            </div>
          ))}
        </section>
      </div>
    </>
  );
}
